<template>
  <v-container
    id="regular-tables-view"
    fluid
    tag="section"
  >
    <material-card
      icon="mdi-account"
      icon-small
      title="لیست وام ها"
      color="accent"
    >
      <v-row v-if="!userloans || userloans.length == 0">
        <v-col cols="12">
          <div class="red--text text-h4 text-center">
            تاکنون وامی برای شما ثبت نشده است.
          </div>
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col
          v-for="l in userloans"
          :key="l.id"
          cols="12"
          md="12"
        >
          <v-card
            class=""
            outlined
          >
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-title class="headline mb-1">
                  {{ l.loanModel.title }}
                </v-list-item-title>
                <v-list-item-subtitle>تاریخ شروع: {{ l.startDate_Persian.date }}</v-list-item-subtitle>
                <v-list-item-subtitle>مبلغ وام: {{ l.amount.toString().toPriceFormat() }} ریال</v-list-item-subtitle>
                <v-list-item-subtitle>تعداد اقساط: {{ l.month }}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-content>
                <v-list-item-title class="headline mb-1">
                  بازپرداخت ها
                </v-list-item-title>
                <v-list-item-subtitle>تعداد اقساط پرداختی: {{ l.paidCount }}</v-list-item-subtitle>
                <v-list-item-subtitle>اقساط پرداخت شده: {{ l.paid.toString().toPriceFormat() }} ریال</v-list-item-subtitle>
                <v-list-item-subtitle>مبلغ باقیمانده: {{ l.remain.toString().toPriceFormat() }} ریال</v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-avatar
                tile
                rounded="round"
                size="80"
                color="grey"
              />
            </v-list-item>

            <v-card-actions>
              <v-btn
                outlined
                rounded
                text
                @click="showInstallments(l)"
              >
                مشاهده اقساط
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <v-dialog
        v-model="dialogInstallments"
        max-width="900px"
      >
        <v-card>
          <v-card-title>
            <span class="headline">لیست اقساط</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <loan-installments
                ref="installments"
                :data="{userloan:selectedUserLoan}"
                @back="activeTab = 0"
              />
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              @click="dialogInstallments = false"
            >
              بستن
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </material-card>
    <confirm-dlg ref="confirm" />
    <div class="py-3" />
  </v-container>
</template>

<script>
  import api from '@/util/app-api'
  import toast from '@/util/toast'
  import LoanInstallments from '../admin/LoanInstallments.vue'

  export default {
    name: 'MemberLoansView',
    components: {
      ConfirmDlg: () => import('@/components/Confirm'),
      'loan-installments': LoanInstallments,
    },
    data () {
      return {
        errorMessages: '',
        localData: {},
        selectedUserLoan: {},
        dialogInstallments: false,
        search: '',
        userloans: [],
      }
    },
    mounted () {
      this.loadData()
    },
    methods: {
      loadData () {
        api.get('member/userloan/get', null)
          .then(
            response => {
              this.userloans = response
            })
          .catch(err => {
            toast.error(err.message)
          })
      },
      showInstallments (item) {
        this.selectedUserLoan = item
        this.dialogInstallments = true
        this.$nextTick(() => {
          this.$refs.installments.loadData()
        })
      },
    },
  }
</script>
<style>
</style>
